module.exports = __webpack_public_path__ + "assets/svg/Icons/48/date-blue-536891.svg";